import React from "react";

import { get, isEmpty } from "lodash";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Container, Grid, Icon } from "semantic-ui-react";

import { useSelectPropertyFromContextById } from "../context/PropertiesContext";
import { PropertyChannelEditor } from "../PropertyChannelEditor";

import "../../node_modules/react-image-gallery/styles/css/image-gallery-no-icon.css";

/**
 * Renders a row with two buttons. One lets the user navigate back to his
 * properties. The other one lets him navigate to the availabilities form.
 */
const NavigationButtonsRow = ({ propertyId }) => (
  <Grid.Row>
    <Grid.Column width={8}>
      <Link to="/myProperties">
        <Button icon>
          <Icon name="angle left" /> Back to my Properties
        </Button>
      </Link>
    </Grid.Column>
    <Grid.Column width={8} textAlign="right">
      <Link to={`/myProperties/${propertyId}/availabilities`}>
        <Button icon>
          <Icon name="calendar alternate outline" /> Edit Availabilities
        </Button>
      </Link>
    </Grid.Column>
  </Grid.Row>
);

export const PropertySettingsPage = ({ match }) => {
  const propertyId = get(match, "params.propertyId");

  const property = useSelectPropertyFromContextById(propertyId);

  if (!propertyId || isEmpty(property)) {
    return null;
  }

  return (
    <Container>
      <Grid>
        <NavigationButtonsRow propertyId={propertyId} />
        <Grid.Row>
          <Grid.Column width="16">
            <PropertyChannelEditor propertyId={propertyId} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

//
// Prop Types
//

NavigationButtonsRow.propTypes = {
  propertyId: PropTypes.string.isRequired,
};

PropertySettingsPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      propertyId: PropTypes.string.isRequired,
    }),
  }),
};
